<template>
  <div class="tab-content">
    <Information ref="information" />
    <Detail />
    <Marketplace v-if="marketplaceIntegration" ref="marketplace" />
  </div>
</template>

<script>
import Information from "./views/Information/Index";
import Detail from "./views/Detail/Index";
import Marketplace from "./views/Marketplace/Index";

import { mapState } from "vuex";
export default {
  name: "Content",
  components: {
    Information,
    Detail,
    Marketplace,
  },
  computed: {
    ...mapState({
      config: (state) => state.session.config,
    }),
    marketplaceIntegration() {
      return (
        this.config["site.marketplace_integration"] == "1" ||
        this.config["site.marketplace_integration"] == 1
      );
    },
  },
};
</script>
